module.exports = __webpack_public_path__ + "img/stock3.3c749e88.png";